/**
 *
 * MeasurementDetails
 *
 */

import React from "react"
import {
  Button,
  Input,
  Dropdown,
  Menu,
  Tooltip,
  message,
  Popover,
  Radio,
  Checkbox,
  Tag,
} from "antd"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { get, filter, isEqual, some, map, uniq, uniqBy, debounce } from "lodash"

import { updateCheckOrganigram, resendSurveyToNews } from "services/measurement"
import injectSaga from "utils/injectSaga"
import ModalCustom from "components/ModalCustom"
import injectReducer from "utils/injectReducer"
import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectIsLoading,
  makeSelectDimensions,
  makeSelectMetricTotal,
  makeSelectMeasureClimate,
  makeSelectIsLoadingStatus,
  makeSelectIsLoadingDivisionsMeasure,
  makeSelectDivisionsMeasure,
  makeSelectDivisionsMeasureMeta,
  makeSelectQualitativeQuestions,
  makeSelectIsLoadingQualitative,
  makeSelectProgDates,
  makeSelectIsLoadingDates,
  makeSelectCountCollaborators,
  makeSelectIsLoadingRecipients,
  makeSelectAddRecipients,
  makeSelectIsLoadingDatesProgramming,
  makeSelectDatesProgramming,
  makeSelectIsLoadingSurveysType,
  makeSelectSurveysType,
  makeSelectLeadersDetails,
  makeSelectIsLoadingLeadersDetails,
  makeSelectLeadersDetailsMeta,
  makeSelectIsLoadingDivisionsTreeMeasure,
  makeSelectDivisionsTreeMeasure,
  makeShowIncludeSubDivisions,
  makeSelectMeasureRangeColor,
  makeSelectRecipientsSegments,
  makeSelectIsLoadingRecipientsSegments,
  makeSelectListPossibleRecipients,
  makeSelectIsLoadingAddCollaborators,
  makeSelectMeasureEngagement,
  makeSelectMeasureGeneral,
  makeSelectMeasureTotal,
  makeSelectMeasureInfo,
  makeSelectDimensionsRank,
  makeSelectIsLoadingDimensionsRank,
  makeSelectDetailCounts,
  makeSelectIsLoadingDetailCounts,
  makeSelectMeasureRate,
  makeSelectIsLoadingMeasureRate,
} from "./selectors"
import {
  getDimensionsWatcher,
  getStatusWatcher,
  getDivisionsMeasureWatcher,
  getDateProgWatcher,
  editMeasurementNameWatcher,
  deleteMeasureWatcher,
  resendSurveyWatcher,
  getRecipientsWatcher,
  postRecipientsWatcher,
  getDatesWatcher,
  editDatesWatcher,
  downloadRecipientsWatcher,
  getSurveysTypeWatcher,
  getLeadersDetailsWatcher,
  sendTestMeasureWatcher,
  postExportReportWatcher,
  deleteCollDivWatcher,
  resendCollDivWatcher,
  getMeasureColorRangeWatcher,
  getRecipientsSegmentsWatcher,
  getLeadersSegmentsWatcher,
  getPossibleRecipientsWatcher,
  addCollaboratorsWatcher,
  getMeasureEngagementWatcher,
  getMeasureGeneralWatcher,
  getMeasureTotalWatcher,
  getMeasureInfoWatcher,
  getDimensionsRankWatcher,
  getQualitativeQuestionWatcher,
  getDetailCountsWatcher,
  getMeasureRateWatcher,
} from "./actions"

import ResultDimensionTable from "../Reports/DimensionByDivision/ResultDimensionTable"
import ResultEnps from "containers/Report/Home/Components/ResultEnps"
import Widgets from "components/Widgets"

import MeasurementDetailsTable from "components/MeasurementDetailsTable"
import WidgetInitHeaderDetails from "components/WidgetInitHeaderDetails"
import WidgetInitHeaderDetailsSegment from "components/WidgetInitHeaderDetailsSegment"
import ModalSendTestSurvey from "components/ModalSendTestSurvey"
import ModalEditMeasure from "components/ModalEditMeasure"
import ModalExportReportMeasure from "components/ModalExportReportMeasure"
import deleteIconRed from "../../images/delete-red.svg"
import addAddressees from "../../images/add-addressees.svg"
import pencilGray from "../../images/pencil-gray.svg"
import sendProofIcon from "../../images/send-proof-icon.svg"
import xIcon from "../../images/x.svg"
import alertSvg from "../../images/alert.svg"
import QualitativeQuestion from "containers/Report/Home/Components/QualitativeQuestion"
import AddCollaboratorsModal from "components/AddCollaboratorsModal"
import MeasurementLeadersDetails from "components/MeasurementLeadersDetails"
import Loader from "components/Loader"
import "./index.less"
import { Link } from "react-router-dom"
import { copyToClipboard } from "../../utils/utils"
import {
  LeftOutlined,
  SearchOutlined,
  LinkOutlined,
  SyncOutlined,
  DownloadOutlined,
  QuestionCircleFilled,
} from "@ant-design/icons"
import MeasurementDetailsSegmentsTable from "../../components/MeasurementDetailsSegmentsTable"
import { SCOPE_TYPE, TYPE_SURVEY } from "../../utils/constants"
import AddCollaboratorsClimateSegmentsModal from "../../components/AddCollaboratorsClimateSegmentsModal"
import AddCollaboratorsLeadersSegments from "../../components/AddCollaboratorsLeadersSegments"
import ellipseIcon from "../../images/ellipse.svg"
import ThreePointsIcon from "../../components/Icon/ThreePointsIcon"
import { LOCAL_USER_ID } from "../../utils/storage"
import {
  buttonAction_btns,
  buttonAction_s,
} from "../../components/Snowplow/config2"

// snowplow
let buttonAction_btn = (tipo) => {
  let data_button_prev = {
    category: window.location.hash
      ? window.location.hash
      : window.location.pathname,
    action: tipo,
    label: `Click a ${tipo}`,
    property: "button",
    value: LOCAL_USER_ID(),
  }
  buttonAction_s(data_button_prev)
}
/* eslint-disable react/prefer-stateless-function */
export class MeasurementDetails extends React.Component {
  state = {
    modalAddCollaborators: false,
    modalAddCollaboratorsClimateSegments: false,
    modalAddCollaboratorsLeadershipSegments: false,
    searchDivisions: "",
    searchResultByDimension: "",
    modalResendSurvey: false,
    modalDeleteMeasure: false,
    showAlert: false,
    showAlertResendSurveyToNews: false,
    modalEditMeasure: false,
    modalSendTestSurvey: false,
    modalExportReportMeasure: false,
    modalResendSurveyToNews: false,
    modalResendSurveyToNewsLoading: false,
    destinationView: 1,
    checkIncludeSubdivisions: true,
    employeesAndSurveys: [],
    employeesSelected: [],
    showChangeOrgAlert: true
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  // Debounced search function that calls the backend API for leaders
  debouncedSearchLeaders = debounce((searchValue) => {
    const {
      match: { params },
      measureStatus,
    } = this.props

    this.props.getLeadersDetailsWatcher({
      id_measure: params.id,
      params: {
        id_measure_status: measureStatus.id_measure_status,
        page: 1,
        per_page: 15,
        search: searchValue,
      },
    })
  }, 500)

  // Debounced search function that calls the backend API for divisions
  debouncedSearchDivisions = debounce((searchValue) => {
    const {
      match: { params },
      measureStatus,
    } = this.props
    const { checkIncludeSubdivisions } = this.state

    this.props.getDivisionsMeasureWatcher({
      idMeasure: params.id,
      params: {
        include: checkIncludeSubdivisions,
        id_measure_status: measureStatus.id_measure_status,
        page: 1,
        per_page: 15,
        search: searchValue,
      },
    })
  }, 500)

  handleSearchDivisions = (e) => {
    const searchValue = e.target.value
    this.setState({ searchDivisions: searchValue })
    
    const segmentationType = get(
      this.props.measureStatus,
      'survey_type.id_survey_segmentation_type',
      1
    )
    
    // Si es tipo 2 (líderes), llamar al backend con debounce
    if (segmentationType === 2) {
      this.debouncedSearchLeaders(searchValue)
    } else {
      // Si es tipo 1 (divisiones), llamar al backend con debounce
      this.debouncedSearchDivisions(searchValue)
    }
  }

  handleTablePaginationChange = (pagination) => {
    const {
      match: { params },
      measureStatus,
    } = this.props
    const { checkIncludeSubdivisions } = this.state

    this.props.getDivisionsMeasureWatcher({
      idMeasure: params.id,
      params: {
        include: checkIncludeSubdivisions,
        id_measure_status: measureStatus.id_measure_status,
        page: pagination.current,
        per_page: pagination.pageSize,
      },
    })
  }

  loadData = () => {
    const {
      match: { params },
    } = this.props

    this.props.getStatusWatcher(params.id)
    this.props.getRecipientsWatcher(params.id)
    this.props.getDimensionsWatcher(params.id)
    this.props.getDimensionsRankWatcher(params.id)
    
    this.props.getPossibleRecipientsWatcher({
      idMeasure: params.id,
    })
    this.props.getDateProgWatcher(params.id)
    this.props.getDatesWatcher({ idMeasure: params.id, params: {} })
    this.props.getMeasureEngagement({ idMeasure: params.id, params: {} })
    this.props.getMeasureGeneral({ idMeasure: params.id, params: {} })
    this.props.getMeasureTotal({ idMeasure: params.id, params: {} })
    this.props.getMeasureInfo({ idMeasure: params.id, params: {} })

    this.setState({
      showAlert: !!get(this.props.measureStatus, "change_org", false),
      showAlertResendSurveyToNews: false,
    })
  }

  componentDidMount = () => {
    const {
      match: { params },
    } = this.props

    this.loadData()

    this.props.getMeasureRangeColorWatcher({
      measure: params.id,
    })
  }

  componentDidUpdate(newProps, nextState) {
    const { checkIncludeSubdivisions } = this.state
    const {
      match: { params },
    } = this.props

    if (nextState.checkIncludeSubdivisions !== checkIncludeSubdivisions) {
      this.props.getDivisionsMeasureWatcher({
        idMeasure: params.id,
        params: { include: checkIncludeSubdivisions },
      })
    }   

    if (newProps.measureInfo !== this.props.measureInfo) {
      if (newProps.measureInfo.id_survey) {
        this.props.getQualitativeQuestionWatcher(newProps.measureInfo.id_survey)
      }
    }

    if (!isEqual(newProps.measureStatus, this.props.measureStatus)) {
      if (this.props.measureStatus.id_scope_type === 2) {
        if (
          this.props.measureStatus.survey_type.id_survey_segmentation_type === 1
        ) {
          this.props.getRecipientsSegmentsWatcher(params.id)
        }
        if (
          this.props.measureStatus.survey_type.id_survey_segmentation_type === 2
        ) {
          this.props.getLeadersSegmentsWatcher(params.id)
        }
      }
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const {
      match: { params },
    } = this.props

    if (!isEqual(this.props.measureStatus, nextProps.measureStatus)) {
      this.props.getSurveysTypeWatcher(
        get(nextProps, "measureStatus.id_survey_type", 1)
      )

      if (nextProps.measureStatus.id_survey) {
        this.props.getQualitativeQuestionWatcher(
          nextProps.measureStatus.id_survey
        )
      }

      this.props.getDivisionsMeasureWatcher({
        idMeasure: params.id,
        params: { include: true, id_measure_status: nextProps.measureStatus.id_measure_status },
      })

      this.setState({
        showAlert: !!get(nextProps.measureStatus, "change_org", false),
        showAlertResendSurveyToNews: false,
        employeesAndSurveys: [],
        employeesSelected: [],
      })
    }

    if (
      nextProps.isLoadingAddCollaborators === false &&
      !isEqual(
        this.props.isLoadingAddCollaborators,
        nextProps.isLoadingAddCollaborators
      )
    ) {
      this.setState(
        {
          modalAddCollaboratorsClimateSegments: false,
          modalAddCollaboratorsLeadershipSegments: false,
          employeesSelected: [],
        },
        () => {
          this.props.getPossibleRecipientsWatcher({
            idMeasure: params.id,
          })
        }
      )
    }

    if (params.id !== nextProps.match.params.id) this.loadData()
  }

  emptyValues(text) {
    return [{}, null, undefined, "", []].includes(text)
  }

  dataSourceForSegments = () => {
    const { searchDivisions } = this.state

    const newList = this.props.listRecipientsSegments.map((item) => {
      item.children = item.recipients_array
      return item
    })

    if (searchDivisions) {
      const divisions = filter(newList, (item) => {
        return (
          item.name.toLowerCase().includes(searchDivisions.toLowerCase()) ||
          some(item.children, (element) => {
            return element.full_name
              .toLowerCase()
              .includes(searchDivisions.toLowerCase())
          })
        )
      })

      if (searchDivisions && divisions.length) {
        return map(divisions, (item) => {
          const isTitle = item.name
            .toLowerCase()
            .includes(searchDivisions.toLowerCase())

          return {
            ...item,
            children: isTitle
              ? item.children
              : filter(item.children, (element) => {
                return element.full_name
                  .toLowerCase()
                  .includes(searchDivisions.toLowerCase())
              }),
          }
        })
      }
    }

    let response = Array.isArray(newList) ? newList : []
    const sorter = (a, b) => {
      return parseInt(b.rate.rate) - parseInt(a.rate.rate)
    }
    return response.sort(sorter)
  }

  dataSourceForDivisions = () => {
    const { checkIncludeSubdivisions } = this.state

    // El filtrado de búsqueda ahora se hace en el backend
    let response = Array.isArray(this.props.divisionsMeasure)
      ? this.props.divisionsMeasure
      : []
    const sorter = (a, b) => {
      // orderBy by Not IncludeSubdivisions
      // eslint-disable-next-line
      if (
        !this.emptyValues(a.rate.rate_recipient_survey_done) &&
        checkIncludeSubdivisions
      ) {
        return parseInt(b.rate.rate) - parseInt(a.rate.rate)
      }

      // orderBy by IncludeSubdivisions
      // eslint-disable-next-line
      if (
        !this.emptyValues(a.rate_subdivision) &&
        !checkIncludeSubdivisions &&
        !this.emptyValues(a.rate_subdivision.rate_recipient_survey_done)
      ) {
        // eslint-disable-next-line
        return (
          parseInt(b.rate_subdivision.rate) - parseInt(a.rate_subdivision.rate)
        )
      }

      // orderBy by default
      if (checkIncludeSubdivisions) {
        return parseInt(b.rate.rate) - parseInt(a.rate.rate)
      }
    }

    return response.sort(sorter)
  }

  dataSourceForLeaders = () => {
    // El filtrado se hace en el backend con el parámetro search
    return Array.isArray(this.props.leadersDetails)
      ? this.props.leadersDetails
      : []
  }

  dataSourceResultDimension = () => {
    const { searchResultByDimension } = this.state

    if (searchResultByDimension) {
      return filter(this.props.dimensions, (item) => {
        return item.dimension_name
          .toLowerCase()
          .includes(searchResultByDimension.toLowerCase())
      })
    }

    return this.props.dimensions
  }

  addCollaborators = () => {
    const { employeesSelected, employeesAndSurveys } = this.state
    const {
      match: { params },
    } = this.props
    const idSurveyType = get(
      this.props,
      "measureStatus.id_survey_type",
      1
    )

    const idSurveySegmentationType = get(
      this.props,
      "measureStatus.survey_type.id_survey_segmentation_type",
      1
    )

    if (idSurveySegmentationType === 1) {
      let dataEmployees = []
      employeesSelected.forEach((item) => {
        if (item.surveys.length === 1) {
          dataEmployees.push({
            id_employee: item.employee.id_employee,
            measures_has_surveys: item.surveys[0].measures_has_surveys,
          })
        } else {
          const employee = employeesAndSurveys.find(
            (employee) => employee.id_employee === item.employee.id_employee
          )
          item.surveys.forEach((survey) => {
            if (employee.id_survey === survey.id_survey) {
              dataEmployees.push({
                id_employee: item.employee.id_employee,
                measures_has_surveys: survey.measures_has_surveys,
              })
            }
          })
        }
      })
      this.props.addCollaboratorsWatcher({
        recipients: dataEmployees,
        idMeasure: params.id,
        idSurveyType,
      })
    }

    if (idSurveySegmentationType === 2) {
      let recipientsData = []
      let arrayTest = []
      employeesSelected.forEach((item) => {
        if (!item.employee) {
          arrayTest.push({
            id_employee: item.id_employee,
            id_recipient_leader: item.id_recipient_leader,
          })
        }
      })

      let uniqRecipientLeader = uniqBy(arrayTest, "id_recipient_leader")

      uniqRecipientLeader.forEach((item) => {
        recipientsData.push({
          id_recipient_leader: item.id_recipient_leader,
          team_array: arrayTest
            .map((el) => {
              if (el.id_recipient_leader === item.id_recipient_leader) {
                return { id_employee: el.id_employee }
              }
            })
            .filter(Boolean),
        })
      })

      this.props.addCollaboratorsWatcher({
        recipients: recipientsData,
        idMeasure: params.id,
        idSurveyType,
      })
    }
  }

  showMeasureLabel = () => {
    // eslint-disable-next-line
    /*const typeSurvey = get(
      this.props,
      // "measureStatus.id_survey_type",
      "measureStatus.id_survey_type",
      null
    )

    // eslint-disable-next-line
    let response = get(
      this.props,
      // "measureStatus.metric_total_label",
      "measureStatus.metric_total_label",
      ""
    )
    if (typeSurvey === 2) {
      // eslint-disable-next-line
      response = get(this.props, "measureStatus.survey.survey_type", "")
    }*/

    return get(this.props, "measureStatus.metric_total_label", "")
  }

  showWidgetMeasureDetails = () => {
    const {
      match: { params },
    } = this.props

    const measureStatus = this.props.measureStatus
    const measureGeneral = this.props.measureGeneral
    const scopeType = get(measureStatus, "id_scope_type", 1)
    const measureType = get(measureStatus, "id_survey_type", 1)
    const isTypeLeaderShip = measureType === TYPE_SURVEY.leadership.idSurveyType
    const measureStatusId = get(measureStatus, "id_measure_status", 3)

    const isEngagement = measureGeneral.is_engagement

    let measureData
    if (isEngagement) {
      measureData = this.props.measureEngagement
    } else {
      measureData = this.props.measureTotal
    }

    return measureStatusId != 5 || scopeType === 1 || isTypeLeaderShip ? (
      <WidgetInitHeaderDetails
        {...this.props}
        showAlert={this.state.showAlert}
        showAlertResendSurveyToNews={this.state.showAlertResendSurveyToNews}
      />
    ) : (
      <WidgetInitHeaderDetailsSegment
        measureTotal={this.props.measureTotal}
        measureData={measureData}
        measureGeneral={this.props.measureGeneral}
        idMeasure={params.id}
      />
    )
  }

  showResultDimensionTable = () => {
    const measureStatus = this.props.measureStatus
    const scopeType = get(measureStatus, "id_scope_type", 1)

    return scopeType === 1 ? (
      <div style={{ padding: "0 24px", marginTop: 24 }}>
        <div className="measurement-details-table-header">
          <span>Resultados por dimensión</span>
          <Input
            allowClear
            onChange={(e) =>
              this.setStateFrom("searchResultByDimension", e.target.value)
            }
            placeholder="Buscar..."
            suffix={!this.state.searchResultByDimension && <SearchOutlined />}
          />
        </div>
        <div className="measurement-details-result-dimensions">
          <ResultDimensionTable
            hideMessageLess25
            measureInfo={this.props.measureInfo}
            isLoading={this.props.isLoading}
            data={this.dataSourceResultDimension()}
            measureColorRange={this.props.measureColorRange}
          />
        </div>
      </div>
    ) : null
  }

  setColorStatus(status) {
    let setColor = ""

    if (status === "borrador") {
      setColor = "#C0C0C0"
    } else if (status === "pendiente") {
      setColor = "#F6B673"
    } else if (status === "en curso" || status === "finalizada") {
      setColor = "#55C8AE"
    }

    return setColor
  }

  tagStatusMeasure = (measure_status) => {
    let text = ""

    switch (measure_status) {
      case 1:
        text = "Borrador"
        break
      case 2:
        text = "Pendiente"
        break
      case 3:
        text = "En curso"
        break
      case 4:
        text = "Finalizada"
        break
      case 5:
        text = "Cerrada"
        break
    }

    let ifClose = {}

    if (text.toLowerCase() === "cerrada") {
      ifClose = {
        backgroundColor: "#B0ACAC",
        color: "#fff",
        width: "fit-content",
      }
    }

    return (
      <span
        className="measurement-history-table-status"
        style={{
          backgroundColor: this.setColorStatus(text.toLowerCase()),
          ...ifClose,
          padding: "4px 8px",
          borderRadius: "4px",
          marginRight: "4px",
        }}>
        {text.toLowerCase() === "en curso" && (
          <img src={ellipseIcon} style={{ marginRight: 6 }} />
        )}
        {text}
      </span>
    )
  }

  showQualitativeQuestion = () => {
    const measureStatus = this.props.measureStatus
    const scopeType = get(measureStatus, "id_scope_type", 1)

    return scopeType === 1 ? (
      <QualitativeQuestion
        isMeasure
        onlyQuestions={this.props.qualitativeQuestions}
        questions={this.props.qualitativeQuestions}
        measure={this.props.match.params.id}
      />
    ) : null
  }

  render() {
    const idScopeType = get(
      this.props,
      "measureStatus.id_scope_type",
      1
    )
    const idSurveyType = get(
      this.props,
      "measureStatus.id_survey_type",
      1
    )

    const onlyEnps =
      get(this.props, "measureStatus.id_measure_status", 0) === 5 &&
      !get(this.props, "measureStatus.survey.engagement", false)

    const showAddAddresses = [3].includes(
      get(this.props, "measureStatus.id_measure_status", 0)
    )

    const showIncludeSubdivisions =
      [3, 4, 5].includes(
        get(this.props.measureStatus, "id_measure_status", 0)
      ) &&
      get(this.props.measureStatus, "id_survey_type", 1) === 1 &&
      this.props.showIncludeSubdivisions

    const idSurveySegmentationType = get(
      this.props,
      "measureStatus.survey_type.id_survey_segmentation_type",
      1
    )

    const menuOptions = (
      <Menu>
        {get(this.props.measureStatus, "id_measure_status", 0) ===
          2 && (
            <Menu.Item
              style={{ color: "#979797" }}
              onClick={() =>
                this.props.history.push(
                  `/models/measure-create/${this.props.match.params.id}`
                )
              }>
              <img src={pencilGray} /> Editar configuración
            </Menu.Item>
          )}
        {showAddAddresses && (
          <Menu.Item
            style={{ color: "#909090" }}
            onClick={() => {
              if (idScopeType === SCOPE_TYPE.typeOrganization) {
                this.setStateFrom("modalAddCollaborators", true)
              } else {
                if (idSurveySegmentationType === 1) {
                  this.setStateFrom(
                    "modalAddCollaboratorsClimateSegments",
                    true
                  )
                }
                if (idSurveySegmentationType === 2) {
                  this.setStateFrom(
                    "modalAddCollaboratorsLeadershipSegments",
                    true
                  )
                }
              }
            }}>
            <img src={addAddressees} style={{ width: 12, height: 12 }} />{" "}
            Agregar destinatarios
          </Menu.Item>
        )}
        <Menu.Item
          style={{ color: "#E37879" }}
          onClick={() => this.setStateFrom("modalDeleteMeasure", true)}>
          <img src={deleteIconRed} style={{ width: 12, height: 12 }} /> Eliminar
        </Menu.Item>
      </Menu>
    )

    const textResendDisable = (
      <div style={{ maxWidth: 240, textAlign: "justify" }}>
        No es posible hacer más de un 1 reenvío en un plazo de{" "}
        <strong>24 horas</strong>. La opción se habilitará nuevamente cuando
        el plazo haya transcurrido.
      </div>
    )

    const recipients_new = get(
      this.props.measureStatus,
      "recipients_new",
      0
    )

    const { destinationView, checkIncludeSubdivisions } = this.state
    const { measureInfo } = this.props
    const hasFreshchat =
    typeof window.Intercom !== "undefined" &&
    window.self === window.top;
    return (
      <React.Fragment>
        <Helmet>
          <title>Modelos - Historial de mediciones</title>
          <meta
            name="description"
            content="Description of MeasurementDetails"
          />
        </Helmet>
        {this.props.isLoading ? (
          <Loader />
        ) : (
          <React.Fragment>
            <div className="measurement-details-header">
              <div>
                {/*this.state.showAlert && (
                  <div className="measurement-details-alert">
                    <span>
                      Se han hecho modificaciones en el organigrama. La <b>medición será reprocesada</b> para incorporar dichos cambios. 
                    </span>
                    <Button
                      onClick={() => {
                        updateCheckOrganigram({
                          measure: this.props.match.params.id,
                        })
                        if (
                          [3].includes(
                            get(
                              this.props.measureStatus,
                              "id_measure_status",
                              0
                            )
                          )
                        ) {
                          if (idScopeType === SCOPE_TYPE.typeOrganization) {
                            this.setStateFrom("modalAddCollaborators", true)
                          } else {
                            if (
                              idSurveyType === TYPE_SURVEY.climate.idSurveyType
                            ) {
                              this.setStateFrom(
                                "modalAddCollaboratorsClimateSegments",
                                true
                              )
                            }

                            if (
                              idSurveyType ===
                              TYPE_SURVEY.leadership.idSurveyType
                            ) {
                              this.setStateFrom(
                                "modalAddCollaboratorsLeadershipSegments",
                                true
                              )
                            }
                          }
                        } else {
                          this.props.history.push(
                            `/models/measure-create/${this.props.match.params.id}`
                          )
                        }
                      }}>
                      Agregar destinatarios
                    </Button>
                    <img
                      src={xIcon}
                      onClick={() => {
                        updateCheckOrganigram({
                          measure: this.props.match.params.id,
                        })
                        this.setStateFrom("showAlert", false)
                      }}
                    />
                  </div>
                )*/}
                {
                  (this.state.showChangeOrgAlert && 
                    (get(this.props, 'measureStatus.force_reprocess') || get(this.props, 'measureStatus.company_has_new_employees')) &&  
                    [3, 4].includes(get(this.props, 'measureStatus.id_measure_status')))
                  ? (
                    <div className="measurement-details-alert">
                    <span>
                      Se han hecho modificaciones en el organigrama. La <b>medición será reprocesada</b> para incorporar dichos cambios.
                    </span>
                    {(get(this.props, 'measureStatus.company_has_new_employees')) && 
                      <Button
                        onClick={() => {
                          if (get(this.props, 'measureStatus.id_scope_type') === SCOPE_TYPE.typeOrganization) {
                            this.setStateFrom("modalAddCollaborators", true)
                          } else {
                            if (get(this.props,"measureStatus.survey_type.id_survey_segmentation_type") === 1) {
                              this.setStateFrom(
                                "modalAddCollaboratorsClimateSegments",
                                true
                              )
                            }
                            if (get(this.props,"measureStatus.survey_type.id_survey_segmentation_type") === 2) {
                              this.setStateFrom(
                                "modalAddCollaboratorsLeadershipSegments",
                                true
                              )
                            }
                          }
                      }}>
                        Agregar destinatarios
                      </Button>
                    }
                    <img
                      src={xIcon}
                      onClick={() =>
                        this.setState({ showChangeOrgAlert: false })
                      }
                    />
                  </div>
                ) : <></>}
              </div>

              <div>
                <div style={{ width: "90%" }}>
                  <div
                    className="btnBack"
                    style={{ marginBottom: 8 }}
                    onClick={() => {
                      this.props.history.push("/models/measure-history")
                      buttonAction_btns("Historial de mediciones")
                    }}>
                    <LeftOutlined type="left" />
                    Historial de mediciones
                  </div>

                  <div className="survey-container-title title_section">
                    {!this.props.isLoadingStatus && (
                      <div>
                        {get(this.props, "measureStatus.name", "")}{" "}
                        <span style={{ color: "#A6A6A6" }}>
                          - {this.showMeasureLabel()}{" "}
                          {get(this.props, "measureInfo.is_engagement", false) && (
                            <span
                              style={{
                                marginLeft: "8px",
                                padding: "4px 8px",
                                borderRadius: "3px",
                                background: "rgba(44, 91, 255, 0.1)",
                                color: "#2C5BFF",
                                fontWeight: "600",
                              }}>
                              Engagement
                            </span>
                          )}
                        </span>
                        {![5].includes(
                          get(
                            this.props.measureStatus,
                            "id_measure_status",
                            0
                          )
                        ) && (
                            <Tooltip title="Editar nombre">
                              <img
                                style={{ cursor: "pointer", marginLeft: 8 }}
                                src={pencilGray}
                                onClick={() => {
                                  // this.props.getSurveysTypeWatcher(get(this.props, 'measureStatus.survey.id_survey_type', 1));
                                  this.setState({ modalEditMeasure: true })
                                }}
                              />
                            </Tooltip>
                          )}
                      </div>)}
                  </div>
                  <div className="measurement-details-header-footer">
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {get(
                        this.props,
                        "measureStatus.id_measure_type",
                        1
                      ) === 2 && (
                          <Popover
                            overlayStyle={{ width: "400px" }}
                            content="La medición no es representativa de toda la población, por lo que sus resultados no serán considerados para el análisis de la evolución histórica del indicador a medir, ni contarán con evolución histórica versus mediciones anteriores.">
                            <Tag color="blue" style={{ fontWeight: 600 }}>
                              Pulso
                            </Tag>
                          </Popover>
                        )}
                      {this.tagStatusMeasure(
                        get(
                          this.props.measureStatus,
                          "id_measure_status",
                          1
                        )
                      )}
                      {this.props.progDates.calendar &&
                        !this.props.progDates.calendar.includes(null) &&
                        `${this.props.progDates.date_send.date.replace(
                          /-/g,
                          "/"
                        )} -
                       ${this.props.progDates.date_end.date.replace(
                          /-/g,
                          "/"
                        )}`}
                      {" | "}
                      {get(
                        this.props,
                        "measureStatus.id_scope_type",
                        1
                      ) === 1
                        ? `Cuestionario: `
                        : `Cuestionarios: `}
                      {get(
                        this.props,
                        "measureStatus.id_scope_type",
                        1
                      ) === 1 ? (
                        ` ${get(
                          this.props.measureStatus,
                          "survey.name",
                          ""
                        )}`
                      ) : (
                        <Tooltip
                          style={{ width: "344px", fontSize: "12px" }}
                          title={() => {
                            return uniq(
                              this.props.measureStatus.surveys.map(
                                (item) => item.name
                              )
                            ).join(", ")
                          }}>
                          {uniq(
                            this.props.measureStatus.surveys.map(
                              (item) => item.name
                            )
                          ).join(", ")}
                        </Tooltip>
                      )}
                    </span>
                    { }
                    {/* get(this.props.measureStatus, "survey.name", "") */}
                  </div>
                </div>
                <div>
                  {![5].includes(
                    get(
                      this.props,
                      "measureStatus.id_measure_status",
                      0
                    )
                  ) && (
                      <Tooltip title="Copiar link">
                        <Button
                          onClick={() => {
                            copyToClipboard(process.env.QUESTIONNAIRE_URL)
                            message.success(
                              "El link de la encuesta ha sido copiado."
                            )
                            buttonAction_btns("Copiar link de medicion")
                          }}>
                          <LinkOutlined />
                        </Button>
                      </Tooltip>
                    )}
                  {![2, 4, 5].includes(
                    get(
                      this.props,
                      "measureStatus.id_measure_status",
                      0
                    )
                  ) ?
                    get(this.props, "measureStatus.active_resend", 0) ? (
                    <Popover
                      placement="bottomRight"
                      content={textResendDisable}>
                      <Button>
                        <SyncOutlined style={{ color: "#B5B5B5" }} />
                      </Button>
                    </Popover>
                  ) : (
                    <Tooltip title="Reenviar">
                      <Button
                        onClick={() => {
                          this.setStateFrom("modalResendSurvey", true)
                          buttonAction_btns("Reenviar medicion")
                        }}>
                        <SyncOutlined />
                      </Button>
                    </Tooltip>
                  ) : <></>}

                  <Tooltip title="Exportar" placement="topRight">
                    <Button
                      onClick={() =>
                        this.props.downloadRecipientsWatcher(
                          this.props.match.params.id
                        )
                      }>
                      <DownloadOutlined />
                    </Button>
                  </Tooltip>

                  <Tooltip title="Enviar prueba">
                    <Button
                      onClick={() => {
                        this.setStateFrom("modalSendTestSurvey", true)
                        buttonAction_btns("Enviar Prueba de medicion")
                      }}
                      style={{ padding: 0 }}>
                      <img
                        src={sendProofIcon}
                        style={{ width: 14, height: 12 }}
                      />
                    </Button>
                  </Tooltip>
                  <Dropdown overlay={menuOptions}>
                    <Button
                      style={{ cursor: "pointer", boxShadow: "none" }}
                      icon={<ThreePointsIcon />}
                    />
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="measurement-content" style={{ ...(typeof window.Intercom !== "undefined" &&
        window.self === window.top && {
        paddingBottom: "6px"}) }}>
            <div
              style={{
                minHeight:
                  get(
                    this.props,
                    "measureStatus.id_measure_status",
                    0
                  ) === 5 &&
                    get(this.props, "measureStatus.survey.engagement", false)
                    ? 256
                    : 219,
              }}>
              {get(this.props, "measureStatus.id_measure_status", 0) ===
                5 &&
                // {  !this.props.isLoadingStatus && (get(this.props, 'measureStatus.id_measure_status', 0) === 5 && (
                get(this.props, "measureStatus.survey.engagement", false) ? (
                // get(this.props, 'measureStatus.enps.engagement', false) ||
                // get(this.props, 'measureStatus.enps.questions_count', 0)
                <div style={{ padding: "16px 24px" }}>
                  <Widgets
                    isLoading={this.props.isLoadingStatus}
                    data={this.props.measureStatus}
                    view_leader={
                      get(
                        this.props.measureStatus,
                        "survey_type.id_survey_segmentation_type",
                        1
                      ) === 2
                    }
                    historyMeasure
                  />
                </div>
              ) : (
                this.showWidgetMeasureDetails()
              )}
            </div>
            <div
              style={{ padding: "0 24px", marginBottom: 0, display: "flex" }}>
              {/* width: onlyEnps ? '60%' : '100%' */}
              <div style={{ marginTop: "1.5rem", width: "100%" }}>
                <div className="measurement-details-table-header">
                  <span>Destinatarios</span>
                  <Input
                    allowClear
                    placeholder={
                      get(
                        this.props.measureStatus,
                        "id_survey_type.survey_type.id_survey_segmentation_type",
                        1
                      ) === 2
                        ? "Buscar equipo..."
                        : "Buscar..."
                    }
                    value={this.state.searchDivisions}
                    onChange={this.handleSearchDivisions}
                    suffix={!this.state.searchDivisions && <SearchOutlined />}
                  />
                </div>
                <div className="measurement-details-table-edit">
                  {!this.props.isLoadingDivisionsMeasure &&
                    this.state.destinationView === 1 ? (
                    get(
                      this.props.measureStatus,
                      "survey_type.id_survey_segmentation_type",
                      1
                    ) === 1 ? (
                      <div>
                        {get(this.props.divisionsMeasureMeta, 'total', 0) === 1
                          ? "1 división"
                          : `${get(this.props.divisionsMeasureMeta, 'total', 0)} divisiones`}{" "}
                        - {get(this.props.divisionsMeasureMeta, 'total_collaborators', 0)} destinatarios
                        programados
                      </div>
                    ) : (
                      <div>
                        {get(this.props.leadersDetailsMeta, 'total', 0) === 1
                          ? "1 equipo"
                          : `${get(this.props.leadersDetailsMeta, 'total', 0)} equipos`}{" "}
                        - {get(this.props.leadersDetailsMeta, 'total_collaborators', 0)} destinatarios
                      </div>
                    )
                  ) : (
                    ""
                  )}
                  {this.state.destinationView === 2 && (
                    <div>
                      {this.props.measureStatus.survey.segments.length === 1
                        ? "1 segmento"
                        : `${this.props.measureStatus.survey.segments.length} segmentos`}{" "}
                      - {this.props.countCollaborators} destinatarios
                    </div>
                  )}
                  {!this.props.isLoadingDivisionsMeasure &&
                    showIncludeSubdivisions &&
                    this.state.destinationView === 1 && (
                      <div>
                        <Checkbox
                          checked={checkIncludeSubdivisions}
                          onChange={(e) =>
                            this.setState({
                              checkIncludeSubdivisions: e.target.checked,
                            })
                          }>
                          Excluir subdivisiones
                        </Checkbox>
                        <Popover
                          placement="topRight"
                          trigger="hover"
                          content={
                            <div style={{ maxWidth: 400, textAlign: "center" }}>
                              Activa el checkbox para visualizar la
                              <br />
                              tasa de respuesta únicamente de los
                              <br />
                              colaboradores dentro de la división, <br />
                              <b>excluyendo</b> a los colaboradores de <br />
                              sus subdivisiones.
                            </div>
                          }>
                          <QuestionCircleFilled className="question-exclude-subdivision" />
                        </Popover>
                      </div>
                    )}
                </div>
                <div>
                  {get(
                    this.props.measureStatus,
                    "survey_type.id_survey_segmentation_type",
                    1
                  ) != 2 ? (
                    <div >
                      <Radio.Group
                        onChange={(e) =>
                          this.setState({ destinationView: e.target.value })
                        }
                        value={destinationView}
                        style={{ margin: "15px 0" }}
                        className="radioButtons">
                        <Radio.Button value={1}>Divisiones</Radio.Button>
                        {get(
                          this.props.measureStatus,
                          "id_scope_type",
                          1
                        ) === 2 &&
                          get(
                            this.props.measureStatus,
                            "survey_type.id_survey_segmentation_type",
                            1
                          ) === 1 && (
                            <Radio.Button value={2}>Segmentos</Radio.Button>
                          )}
                        {/* <Radio.Button value={2}>Árbol</Radio.Button> */}
                      </Radio.Group>
                      {destinationView === 1 ? (
                        <MeasurementDetailsTable
                          idStatus={get(
                            this.props.measureStatus,
                            "id_measure_status",
                            0
                          )}
                          idSurveyType={get(
                            this.props.measureStatus,
                            "id_survey_type",
                            0
                          )}
                          onlyEnps={onlyEnps}
                          match={this.props.match}
                          loading={this.props.isLoadingDivisionsMeasure}
                          deleteCollDivWatcher={this.props.deleteCollDivWatcher}
                          resendCollDivWatcher={this.props.resendCollDivWatcher}
                          data={this.dataSourceForDivisions()}
                          treeData={this.props.divisionsTreeMeasure}
                          dataOriginal={this.props.divisionsMeasure}
                          isSearching={this.state.searchDivisions}
                          checkIncludeSubdivisions={
                            this.state.checkIncludeSubdivisions
                          }
                          pagination={this.props.divisionsMeasureMeta}
                          onTableChange={this.handleTablePaginationChange}
                          measureStatus={this.props.measureStatus}
                        />
                      ) : (
                        <MeasurementDetailsSegmentsTable
                          idStatus={get(
                            this.props.measureStatus,
                            "id_measure_status",
                            0
                          )}
                          onlyEnps={onlyEnps}
                          match={this.props.match}
                          loading={this.props.isLoadingRecipientsSegments}
                          deleteCollDivWatcher={this.props.deleteCollDivWatcher}
                          resendCollDivWatcher={this.props.resendCollDivWatcher}
                          data={this.dataSourceForSegments()}
                          treeData={this.props.divisionsTreeMeasure}
                          dataOriginal={this.props.listRecipientsSegments}
                          isSearching={this.state.searchSegments}
                          checkIncludeSubdivisions={
                            this.state.checkIncludeSubdivisions
                          }
                        />
                      )}
                    </div>
                  ) : (
                    <MeasurementLeadersDetails
                      idStatus={get(
                        this.props.measureStatus,
                        "id_measure_status",
                        0
                      )}
                      isSearching={this.state.searchDivisions}
                      searchTerm={this.state.searchDivisions}
                      measureStatus={this.props.measureStatus}
                      deleteCollDivWatcher={this.props.deleteCollDivWatcher}
                      resendCollDivWatcher={this.props.resendCollDivWatcher}
                      getLeadersDetailsWatcher={
                        this.props.getLeadersDetailsWatcher
                      }
                      match={this.props.match}
                      leadersDetails={this.dataSourceForLeaders()}
                      isLoadingLeadersDetails={
                        this.props.isLoadingLeadersDetails
                      }
                      pagination={this.props.leadersDetailsMeta}
                    />
                  )}
                </div>
              </div>
              {!!get(this.props, "measureStatus.enps.questions_count", 0) &&
                get(this.props, "measureStatus.id_survey_type", 0) ===
                1 &&
                get(
                  this.props,
                  "measureStatus.id_measure_status",
                  0
                ) === 5 &&
                !get(this.props, "measureStatus.survey.engagement", false) && (
                  <ResultEnps
                    historyMeasure
                    data={this.props.measureStatus.enps}
                  />
                )}
            </div>
            {get(this.props.measureStatus, "id_measure_status", 0) ===
              5 && (
                <React.Fragment>
                  {this.showResultDimensionTable()}
                  {!this.props.isLoadingStatus && (
                    <div style={{ padding: "0 24px", paddingBottom: 24 }}>
                      {this.showQualitativeQuestion()}
                    </div>
                  )}
                </React.Fragment>
              )}
              </div>
          </React.Fragment>
        )}
        <AddCollaboratorsModal
          survey={get(this.props, "measureStatus.survey", {})}
          idMeasure={this.props.match.params.id}
          isLoadingRecipients={this.props.isLoadingRecipients}
          listRecipients={
            Array.isArray(this.props.listRecipients)
              ? this.props.listRecipients
              : []
          }
          postRecipientsWatcher={this.props.postRecipientsWatcher}
          setStateFrom={this.setStateFrom}
          modalOpen={this.state.modalAddCollaborators}
          measureInfo={measureInfo}
        />
        {get(
          this.props,
          "measureStatus.survey_type.id_survey_segmentation_type",
          1
        ) === 1 &&
          get(this.props, "measureStatus.id_scope_type", 0) === 2 && (
            <AddCollaboratorsClimateSegmentsModal
              setStateFrom={this.setStateFrom}
              modalOpen={this.state.modalAddCollaboratorsClimateSegments}
              listPossibleRecipients={
                Array.isArray(this.props.listPossibleRecipients)
                  ? this.props.listPossibleRecipients
                  : []
              }
              employeesAndSurveys={
                Array.isArray(this.state.employeesAndSurveys)
                  ? this.state.employeesAndSurveys
                  : []
              }
              employeesSelected={
                Array.isArray(this.state.employeesSelected)
                  ? this.state.employeesSelected
                  : []
              }
              addCollaborators={this.addCollaborators}
              isLoadingAddCollaborators={this.props.isLoadingAddCollaborators}
            />
          )}
        {(get(
          this.props,
          "measureStatus.survey_type.id_survey_segmentation_type",
          0
        ) === 2 && get(this.props, "measureStatus.id_measure_status", 4) < 4) &&
          get(this.props, "measureStatus.id_scope_type", 0) === 2 && (
            <AddCollaboratorsLeadersSegments
              setStateFrom={this.setStateFrom}
              modalOpen={this.state.modalAddCollaboratorsLeadershipSegments}
              listPossibleRecipients={
                Array.isArray(this.props.listPossibleRecipients)
                  ? this.props.listPossibleRecipients
                  : []
              }
              employeesAndSurveys={
                Array.isArray(this.state.employeesAndSurveys)
                  ? this.state.employeesAndSurveys
                  : []
              }
              employeesSelected={
                Array.isArray(this.state.employeesSelected)
                  ? this.state.employeesSelected
                  : []
              }
              addCollaborators={this.addCollaborators}
              isLoadingAddCollaborators={this.props.isLoadingAddCollaborators}
            />
          )}
        <ModalEditMeasure
          selectSurvey={[1, 2].includes(
            get(this.props.measureStatus, "id_measure_status", 0)
          )}
          visible={this.state.modalEditMeasure}
          nameMeasurement={get(this.props, "measureStatus.name", "")}
          // eslint-disable-next-line
          metricTotalLabel={get(
            this.props,
            "measureStatus.metric_total_label",
            ""
          )}
          measure={get(this.props, "measureStatus", {})}
          setStateFrom={this.setStateFrom}
          editMeasurementNameWatcher={this.props.editMeasurementNameWatcher}
          match={this.props.match}
          surveysType={this.props.surveysType}
          isLoadingSurveysType={this.props.isLoadingSurveysType}
        />
        <ModalExportReportMeasure
          visible={this.state.modalExportReportMeasure}
          setStateFrom={this.setStateFrom}
          postExportReportWatcher={this.props.postExportReportWatcher}
          status={get(this.props, "measureStatus", {})}
        />
        <ModalCustom
          modalOpen={this.state.modalResendSurvey}
          showFooter
          onCancel={() => {
            this.setStateFrom("modalResendSurvey", false)
          }}
          onOk={() => {
            const {
              match: { params },
            } = this.props

            this.props.resendSurveyWatcher({
              idMeasure: params.id,
              params: {
                include: this.props.showIncludeSubdivisions
              }
            })
            this.setStateFrom("modalResendSurvey", false)
          }}>
          <img src={alertSvg} className="alertIcon"  style={{ height:30 }}/>
          <span style={{ fontSize: 14, fontWeight: 600 }}>
            ¿Estás seguro de que deseas reenviar la encuesta?
          </span>
          <p style={{ fontSize: 13 }}>
            Esta será reenviada <strong>únicamente</strong> a aquellos
            colaboradores que aún no la han contestado y tienen un correo asociado.
          </p>
        </ModalCustom>
        <ModalCustom
          modalOpen={this.state.modalDeleteMeasure}
          showFooter
          onCancel={() => this.setStateFrom("modalDeleteMeasure", false)}
          onOk={() => {
            const { match } = this.props

            this.props.deleteMeasureWatcher(match.params.id)
            this.setStateFrom("modalDeleteMeasure", false)
          }}>
          <img src={alertSvg} className="alertIcon" />
          <span style={{ fontSize: 14, fontWeight: 600 }}>
            ¿Estás seguro de que deseas eliminar esta medición?
          </span>
        </ModalCustom>

        <ModalSendTestSurvey
          modalSendTestSurvey={this.state.modalSendTestSurvey}
          stepThirdWatcher={this.props.sendTestMeasureWatcher}
          setStateFrom={this.setStateFrom}
          match={this.props.match}
        />

        <ModalCustom
          modalOpen={this.state.modalResendSurveyToNews}
          showFooter
          onCancel={() => {
            this.setStateFrom("modalResendSurveyToNews", false)
          }}
          isLoadingButton={this.state.modalResendSurveyToNewsLoading}
          onOk={async () => {
            this.setStateFrom("modalResendSurveyToNewsLoading", true)
            try {
              await resendSurveyToNews({ measure: this.props.match.params.id })
              this.setState({
                modalResendSurveyToNews: false,
                modalResendSurveyToNewsLoading: false,
                showAlertResendSurveyToNews: false,
              })
            } catch (error) {
              this.setStateFrom("modalResendSurveyToNewsLoading", false)
            }
          }}>
          <img src={alertSvg} className="alertIcon" />
          <span style={{ fontSize: 14, fontWeight: 600 }}>
            ¿Estás seguro de que deseas enviar la encuesta?
          </span>
          <p style={{ fontSize: 13 }}>
            Esta será enviada <strong>únicamente</strong> a aquellos
            colaboradores que aún no la han contestado.
          </p>
        </ModalCustom>
      </React.Fragment>
    )
  }
}

MeasurementDetails.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  dimensions: makeSelectDimensions(),
  metric_total: makeSelectMetricTotal(),
  isLoadingStatus: makeSelectIsLoadingStatus(),
  measureStatus: makeSelectMeasureClimate(),
  isLoadingDivisionsMeasure: makeSelectIsLoadingDivisionsMeasure(),
  divisionsMeasure: makeSelectDivisionsMeasure(),
  divisionsMeasureMeta: makeSelectDivisionsMeasureMeta(),
  qualitativeQuestions: makeSelectQualitativeQuestions(),
  isLoadingQualitative: makeSelectIsLoadingQualitative(),
  progDates: makeSelectProgDates(),
  isLoadingDates: makeSelectIsLoadingDates(),
  countCollaborators: makeSelectCountCollaborators(),
  isLoadingRecipients: makeSelectIsLoadingRecipients(),
  listRecipients: makeSelectAddRecipients(),
  isLoadingDatesProgramming: makeSelectIsLoadingDatesProgramming(),
  datesProgramming: makeSelectDatesProgramming(),
  isLoadingSurveysType: makeSelectIsLoadingSurveysType(),
  surveysType: makeSelectSurveysType(),
  leadersDetails: makeSelectLeadersDetails(),
  isLoadingLeadersDetails: makeSelectIsLoadingLeadersDetails(),
  leadersDetailsMeta: makeSelectLeadersDetailsMeta(),
  isLoadingDivisionsTreeMeasure: makeSelectIsLoadingDivisionsTreeMeasure(),
  divisionsTreeMeasure: makeSelectDivisionsTreeMeasure(),
  showIncludeSubdivisions: makeShowIncludeSubDivisions(),
  measureColorRange: makeSelectMeasureRangeColor(),
  listRecipientsSegments: makeSelectRecipientsSegments(),
  isLoadingRecipientsSegments: makeSelectIsLoadingRecipientsSegments(),
  listPossibleRecipients: makeSelectListPossibleRecipients(),
  isLoadingAddCollaborators: makeSelectIsLoadingAddCollaborators(),
  measureEngagement: makeSelectMeasureEngagement(),
  measureGeneral: makeSelectMeasureGeneral(),
  measureTotal: makeSelectMeasureTotal(),
  measureInfo: makeSelectMeasureInfo(),
  dimensionRanks: makeSelectDimensionsRank(),
  isLoadingDimensionsRank: makeSelectIsLoadingDimensionsRank(),
  detailCounts: makeSelectDetailCounts(),
  isLoadingDetailCounts: makeSelectIsLoadingDetailCounts(),
  measureRate: makeSelectMeasureRate(),
  isLoadingMeasureRate: makeSelectIsLoadingMeasureRate(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDimensionsWatcher: (params) => dispatch(getDimensionsWatcher(params)),
    getStatusWatcher: (params) => dispatch(getStatusWatcher(params)),
    getQualitativeQuestionWatcher: (params) =>
      dispatch(getQualitativeQuestionWatcher(params)),
    getDivisionsMeasureWatcher: (params) =>
      dispatch(getDivisionsMeasureWatcher(params)),
    getDateProgWatcher: (params) => dispatch(getDateProgWatcher(params)),
    editMeasurementNameWatcher: (params) =>
      dispatch(editMeasurementNameWatcher(params)),
    deleteMeasureWatcher: (params) => dispatch(deleteMeasureWatcher(params)),
    resendSurveyWatcher: (params) => dispatch(resendSurveyWatcher(params)),
    getRecipientsWatcher: (params) => dispatch(getRecipientsWatcher(params)),
    getRecipientsSegmentsWatcher: (params) =>
      dispatch(getRecipientsSegmentsWatcher(params)),
    getLeadersSegmentsWatcher: (params) =>
      dispatch(getLeadersSegmentsWatcher(params)),
    postRecipientsWatcher: (params) => dispatch(postRecipientsWatcher(params)),
    getDatesWatcher: (params) => dispatch(getDatesWatcher(params)),
    editDatesWatcher: (params) => dispatch(editDatesWatcher(params)),
    downloadRecipientsWatcher: (params) =>
      dispatch(downloadRecipientsWatcher(params)),
    getSurveysTypeWatcher: (params) => dispatch(getSurveysTypeWatcher(params)),
    getLeadersDetailsWatcher: (params) =>
      dispatch(getLeadersDetailsWatcher(params)),
    sendTestMeasureWatcher: (params) =>
      dispatch(sendTestMeasureWatcher(params)),
    postExportReportWatcher: (params) =>
      dispatch(postExportReportWatcher(params)),
    deleteCollDivWatcher: (params) => dispatch(deleteCollDivWatcher(params)),
    resendCollDivWatcher: (params) => dispatch(resendCollDivWatcher(params)),
    getMeasureRangeColorWatcher: (params) =>
      dispatch(getMeasureColorRangeWatcher(params)),
    getPossibleRecipientsWatcher: (params) =>
      dispatch(getPossibleRecipientsWatcher(params)),
    addCollaboratorsWatcher: (params) =>
      dispatch(addCollaboratorsWatcher(params)),
    getMeasureEngagement: (params) =>
      dispatch(getMeasureEngagementWatcher(params)),
    getDimensionsRankWatcher: (params) =>
      dispatch(getDimensionsRankWatcher(params)),
    getMeasureGeneral: (params) => dispatch(getMeasureGeneralWatcher(params)),
    getMeasureTotal: (params) => dispatch(getMeasureTotalWatcher(params)),
    getMeasureInfo: (params) => dispatch(getMeasureInfoWatcher(params)),
    getDetailCounts: (params) => dispatch(getDetailCountsWatcher(params)),
    getMeasureRate: (params) => dispatch(getMeasureRateWatcher(params))
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "measurementDetails", reducer })
const withSaga = injectSaga({ key: "measurementDetails", saga })

export default compose(withReducer, withSaga, withConnect)(MeasurementDetails)
